import React, { useMemo, useEffect, useState } from 'react';
import { get, debounce } from 'lodash';
import RenderDatepickerFilter from '../Form/RenderDatePickerFilter';
import OnTextOrDateFilter from '../Form/OnTextOrDateFilter';
import TextField from '../TextField/TextField';
import Select from '../Select/Select';
import MenuItem from '../MenuItem/MenuItem';

// TODO https://iotecha.atlassian.net/browse/I2P2-8914 because of the onTextFilter
// if remove onTextFilter - works as expected
export const onTextFilter = (props) => {
  const { filter, onChange, ...rest } = props;
  const filterVal = get(filter, 'value', '');
  const key = !filterVal ? 'empty-key' : get(filter, 'id', 'default-key');

  return <TextField key={key} defaultValue={filterVal} onChange={(e) => onChange(e.target.value)} fullWidth {...rest} />;
};

export const makeDebounceOnTextFilter =
  (howLong = 1000, inputProps) =>
  ({ filter, onChange }) =>
    onTextFilter({ filter, onChange: debounce(onChange, howLong), ...inputProps });

export const onTextFilterNosaving = ({ onChange }) => {
  const forwardChange = debounce(onChange, 500);

  return <TextField onChange={(e) => forwardChange(e.target.value)} fullWidth />;
};

export const onTextOrDatePickerFilter = ({ filter, onChange, isModal }) => (
  <OnTextOrDateFilter filter={filter} onChange={onChange} isModal={isModal} />
);

export const onDatePickerFilter = ({ filter, onChange }) => (
  <RenderDatepickerFilter onChange={onChange} value={filter ? filter.value : ''} />
);

export const onDatePickerFilterTimeStampOutput = ({ filter, onChange }) => (
  <RenderDatepickerFilter onChange={onChange} timestampOutput value={filter ? filter.value : ''} />
);

export const makePersistedTextFilter = (debounceMs = 250) =>
  function PersistedTextFilter({ filter, onChange, ...rest }) {
    const valueFromState = get(filter, 'value', '');
    const [localValue, setLocalValue] = useState(valueFromState);

    useEffect(() => {
      setLocalValue(valueFromState);
    }, [valueFromState]);

    const forwardChange = useMemo(() => debounce(onChange, debounceMs), [onChange, debounceMs]);

    return (
      <TextField
        fullWidth
        value={localValue}
        onChange={(e) => {
          const nextValue = e.target.value;
          setLocalValue(nextValue);
          forwardChange(nextValue);
        }}
        {...rest}
      />
    );
  };

export const makePersistedSelectFilter = (options) =>
  function PersistedSelectFilter({ filter, onChange }) {
    const valueFromState = get(filter, 'value', '');
    const [localValue, setLocalValue] = useState(valueFromState);

    useEffect(() => {
      setLocalValue(valueFromState);
    }, [valueFromState]);

    return (
      <Select
        fullWidth
        autoWidth
        displayEmpty
        value={localValue}
        onChange={(e) => {
          const nextValue = e.target.value;
          setLocalValue(nextValue);
          onChange(nextValue);
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    );
  };
